import { useCallback, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebaseConfig";

// Derivation is a single LLM read over the clone — usually a few seconds, but
// give it room when a provider is slow. The Cloud Function caps at 60s.
const deriveCallable = httpsCallable(functions, "deriveVoiceCloneTemplateSetup", {
  timeout: 70000,
});

// One-click CopyTwin → template auto-setup. Calls the backend to derive a
// ready-to-send campaign brief (goal, pain point, unique advantage, language,
// twin structure) from everything the clone already knows.
export const useTemplateAutoSetup = (userId) => {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(null);

  const deriveSetup = useCallback(
    async ({ cloneId, type }) => {
      if (!userId || !cloneId) return null;
      setPending(true);
      setError(null);
      try {
        const result = await deriveCallable({ cloneId, userId, type });
        return result.data; // { ok, setup, skipped?, reason?, modelUsed? }
      } catch (err) {
        console.warn("[useTemplateAutoSetup] failed:", err);
        setError(err.message || "Auto-setup failed");
        return null;
      } finally {
        setPending(false);
      }
    },
    [userId],
  );

  return { deriveSetup, pending, error };
};
